'use strict';

/**
 * At the time of this writing these constants are shared between the dcs-commands-dynamo-stream-handler
 * and the folder-monitor-command-event-processor, where to former uses he constants as
 * properties in the published SNS topic and the latter does conditional logic on the
 * same properties.
 */
module.exports = {
    REPOSITORY_FACETS: {
        REQUEST: 'REQUEST',
        ATTEMPT: 'ATTEMPT',
        RESPONSE: 'RESPONSE'
    },
    SNS_TOPIC_ATTRIBUTES: {
        COMMAND: 'command',
        FACET: 'facet'
    },
    EVENT_TYPES: {
        REQUEST: 'dcs.command.request',
        ATTEMPT: 'dcs.command.attempt',
        RESPONSE: 'dcs.command.response'
    },
    buildCommandAttribute: function buildCommandAttribute(route, command) {
        return route + '|' + command;
    }
};